import React from 'react';

const methodsOneContext = React.createContext({

///ina to faghat vase in mizarim ke befahmim che chizi pas dadim , mitunim estefade konim vagar na mitunim nazarim

    methodsOneState: [],
    add: () => {},
    edit: () => {},
    done: () => {},
    delete: () => {}
})


export default methodsOneContext;